import { useState, useEffect } from 'react';
import getConfigVars from '#utils/get-config-vars';

const useNewPlayer = () => {
  const [usePlayerV2, setUsePlayerV2] = useState<boolean>(false);

  useEffect(() => {
    const { ENABLE_PLAYER_V2 } = getConfigVars({
      ENABLE_PLAYER_V2: 'false',
    });

    const cookies = document.cookie.split(';').map((c) => c.trim());
    const playerCookie = cookies.find((c) => c.startsWith('usePlayerV2='));
    const playerCookieValue = playerCookie?.split('=')[1];

    if (ENABLE_PLAYER_V2 === 'true' || playerCookieValue === 'true') {
      // TODO: remove before prod
      console.log(
        `[useNewPlayer] Player V2 enabled (config=${ENABLE_PLAYER_V2}, cookie=${playerCookieValue})`
      );
      setUsePlayerV2(true);
    } else {
      // Note: do not print anything if V1, since this will go to prod right now
      setUsePlayerV2(false);
    }
  }, []);

  return { usePlayerV2 };
};

export default useNewPlayer;
